import React from 'react';
import { format, isToday, isYesterday } from 'date-fns';

/**
 * Message Group Component
 * Groups messages under date headers
 *
 * @param {Object} props
 * @param {Date|string} props.date - The date for this group
 * @param {React.ReactNode} props.children - The messages in this group
 * @param {number} props.messageCount - Number of messages in this group
 */
const MessageGroup = React.memo(({ date, children, messageCount = 0 }) => {
    const formatGroupDate = (date) => {
        if (!date) return 'Unknown Date';

        try {
            const dateObj = typeof date === 'string' ? new Date(date) : date;

            if (isToday(dateObj)) {
                return 'Today';
            } else if (isYesterday(dateObj)) {
                return 'Yesterday';
            } else {
                return format(dateObj, 'EEEE, MMMM d, yyyy');
            }
        } catch (error) {
            return 'Invalid Date';
        }
    };

    return (
        <div className="message-group mb-4">
            {/* Date Header */}
            <div className="date-header text-center mb-3">
                <div className="date-badge d-inline-block px-3 py-1 rounded-pill">
                    <span>{formatGroupDate(date)}</span>
                    {messageCount > 0 && (
                        <span className="ms-2  " style={{ fontSize: '12px', color: 'black' }}>
                            {messageCount}
                        </span>
                    )}
                </div>
            </div>

            {/* Messages */}
            <div className="messages-container" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {children}
            </div>
        </div>
    );
});

MessageGroup.displayName = 'MessageGroup';

export default MessageGroup;